import $ from 'jquery';

$('#load_transcript').on('click', function(event) {
  event.preventDefault();

  const node_id = $(this).data('id');
  const transcript_data = $('#transcript_data');
  const button = $(this);
  const transcript_summary = $('#transcript_summary');

  $.ajax( `/sermons/api?nid=${node_id}` )
    .done(function(data) {
      $(transcript_data).append(data[0].field_transcript[0].value);
      $(button).hide();
      $(transcript_summary).hide();
    })
    .fail(function() {
      console.error('An error has occured in the sermons script'); // eslint-disable-line no-console
    });
});
